import React from 'react';
import bimstec from '../assets/images/bimstec.png';

const Bimstec = () => {
  return (
    <div className="bg-gray-100 flex flex-col items-center justify-center p-6">
      <div className="rounded-2xl bg-white p-6 text-center">
        {/* <h1 className="mb-4 text-3xl font-bold text-blue-600">BIMSTEC</h1> */}
        <img
          src={bimstec}
          alt="BIMSTEC Logo"
          className="mx-auto mb-4 h-auto w-[32rem]"
        />
        <div className="mx-auto w-10/12">
          <p className="text-gray-700 mb-4 text-lg">
            The Bay of Bengal Initiative for Multi-Sectoral Technical and
            Economic Cooperation (BIMSTEC) is a regional organization that was
            established on 06 June 1997. Initially known as BIST-EC
            (Bangladesh-India-SriLanka-Thailand Economic Cooperation), the
            organization is now known as BIMSTEC and comprises seven Member
            States with the admission of Myanmar on 22 December 1997, and Bhutan
            and Nepal in February 2004. The Member States of BIMSTEC are the
            People’s Republic of Bangladesh, the Kingdom of Bhutan, the Republic
            of India, the Republic of the Union of Myanmar, Nepal, the
            Democratic Socialist Republic of Sri Lanka, and the Kingdom of
            Thailand. One of the main purposes of BIMSTEC is to accelerate the
            economic growth and social progress in the Bay of Bengal region by
            promoting active collaboration in economic, social, technical and
            scientific fields.
          </p>

          <p>
            The cooperation within BIMSTEC focuses on various sectors and
            subsectors led by different member countries. The details are
            available at https://bimstec.org/bimstec-history/. India is leading
            the sector “Security” which includes the sub-sectors:
            Counter-Terrorism and Transnational Crime, Disaster Management and
            Energy. BIMSTEC Centre for Weather and Climate (BCWC) is under the
            sub-sector “Disaster Management”.
          </p>

          <p>
            The Memorandum of Association (MoA) was signed on 04 March 2014 for
            establishment of BCWC at National Centre for Medium Range Weather
            Forecasting. The objectives of BCWC are: To promote and encourage
            cooperation between BIMSTEC member countries in identified areas of
            fundamental and applied scientific research in weather prediction
            and climate modelling To promote scientific capacity building in
            weather and climate research Encourage and assist the publication of
            important results of research obtained within the framework of the
            BIMSTEC cooperation on weather and climate BCWC is also a very
            important component of the umbrella scheme entitled “Research,
            Education, Training and Outreach (REACHOUT)” of Ministry of Earth
            Sciences, Government of India. It is involved in several activities
            to strengthen the cooperation and collaboration with member nations
            in disaster management and risk reduction. It organizes annual
            workshops and training programs for the capacity building in BIMSTEC
            member countries. It shares various model forecast products (both
            deterministic and probabilistic) on real time with BIMSTEC member
            nations.
          </p>

          <a
            href="https://bimstec.org/bimstec-history/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 rounded-lg bg-blue-600 p-2 px-4 font-semibold text-white shadow transition hover:bg-blue-700"
          >
            Learn More
          </a>
        </div>
      </div>
    </div>
  );
};

export default Bimstec;
